import { render } from "./CorrelationTabs.vue?vue&type=template&id=7a09a585"
import script from "./CorrelationTabs.vue?vue&type=script&lang=js"
export * from "./CorrelationTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__